/** 消息中心(设计图 21):/v1/notifications;学生 / 家长 / 员工共用,`as` 选身份 */
import type { ApiClient } from './client.js';

export type NotifyAudience = 'student' | 'parent' | 'staff';

export interface NotifyLink {
  route?: string;
  params?: Record<string, string>;
  query?: Record<string, string>;
  href?: string;
  label?: string;
}
export interface InboxItem {
  id: string;
  category: string;
  event: string;
  title: string;
  body: string;
  link: NotifyLink | null;
  studentId: string | null;
  read: boolean;
  createdAt: string;
}
export interface InboxPage {
  items: InboxItem[];
  total: number;
  page: number;
  size: number;
}
export interface InboxSummary {
  total: number;
  unread: number;
  categories: { key: string; label: string; total: number; unread: number }[];
}

/** 外壳用户菜单的工作台入口:current = 本站点就能进;否则要切到那个站点登录 */
export interface Workspace {
  role: 'reviewer' | 'judge';
  tenantId: string;
  tenantCode: string;
  tenantName: string;
  current: boolean;
}

/** 平台「外部服务」页 · 系统通知短信 */
export interface NotifySmsOverview {
  mode: 'real' | 'stub';
  dailyLimit: number;
  today: { sent: number; failed: number; unconfigured: number; capped: number; pending: number };
  mapping: { configured: number; errors: string[] };
  events: { event: string; label: string; must: boolean; mapped: boolean }[];
  missing: string[];
  recent: {
    at: string;
    event: string;
    label: string;
    audience: string;
    phone: string;
    status: string;
    reason: string | null;
    text: string | null;
  }[];
}

/** 五类消息的图标与色调(设计图 21:作业蓝 · 考试琥珀 · 成绩绿 · 赛事紫 · 系统灰) */
export const CATEGORY_UI: Record<string, { label: string; icon: string; tone: string }> = {
  homework: { label: '作业', icon: 'doc', tone: 'blue' },
  score: { label: '成绩与徽章', icon: 'chart', tone: 'green' },
  exam: { label: '考试', icon: 'calendar', tone: 'amber' },
  contest: { label: '赛事', icon: 'trophy', tone: 'violet' },
  system: { label: '系统', icon: 'settings', tone: 'gray' },
};

/** 员工看的分类名(同一套五类,措辞换成后台口吻) */
export const STAFF_CATEGORY_LABELS: Record<string, string> = {
  homework: '教学与批改',
  score: '成绩',
  exam: '考务',
  contest: '赛事',
  system: '系统与待办',
};

export function notifyApi(api: ApiClient) {
  const N = '/v1/notifications';
  return {
    list: (q: { as?: NotifyAudience; category?: string; page?: number; size?: number } = {}) =>
      api.get<InboxPage>(N, { query: q }),
    summary: (as?: NotifyAudience) => api.get<InboxSummary>(`${N}/summary`, { query: { as } }),
    read: (id: string, as?: NotifyAudience) =>
      api.post<{ ok: true }>(`${N}/${id}/read`, {}, { query: { as } }),
    readAll: (as?: NotifyAudience, category?: string) =>
      api.post<{ updated: number }>(`${N}/read-all`, {}, { query: { as, category } }),
    workspaces: () => api.get<{ items: Workspace[] }>(`${N}/workspaces`),
    smsOverview: () => api.get<NotifySmsOverview>('/v1/platform/notify-sms'),
  };
}
export type NotifyApi = ReturnType<typeof notifyApi>;
